import { render, staticRenderFns } from "./dynamic-input.vue?vue&type=template&id=57b965b0&scoped=true"
import script from "./dynamic-input.vue?vue&type=script&lang=js"
export * from "./dynamic-input.vue?vue&type=script&lang=js"
import style0 from "./dynamic-input.vue?vue&type=style&index=0&id=57b965b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b965b0",
  null
  
)

export default component.exports